// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {Placement} from 'common/components/tooltip/types';
import {ButtonEl} from 'common/components/button';
import {SpinnerEl} from 'common/components/spinner';
import {SvgIconEl} from 'common/components/svg-icon';
import {TooltipEl} from 'common/components/tooltip';

import {ButtonType} from '../button/constants';
import type {FileUploader} from './index';

export function template(this: FileUploader) {
  const {helpers} = this;
  const icon = this.attr(`icon`);
  const iconEl = icon ? <SvgIconEl attrs={{icon}} /> : ``;

  const uploadButton = (
    <label>
      <ButtonEl
        attrs={{
          theme: this.attr(`button-theme`),
          icon,
          tabindex: 0,
          disabled: this.attr(`disabled`),
          'style-override': this.attr(`style-override`),
        }}
        hook={{insert: helpers.uploadButtonInserted, destroy: helpers.uploadButtonDestroyed}}
        style={this.attr(`button-styling`)}
      >
        {this.attr(`label`)}
        <input
          sel='.upload-block-input'
          attrs={{type: `file`, accept: this.attr(`accept`), disabled: this.attr(`disabled`)}}
          on={{change: helpers.handleChange}}
        />
      </ButtonEl>
    </label>
  );
  const processing = (
    <div sel='.upload-processing'>
      <SpinnerEl /> {this.attr(`processing-description`)}
    </div>
  );
  const complete = (
    <div sel='.upload-complete'>
      <div sel='.filename' class={{'is-disabled': this.attr(`disabled`)}}>
        {iconEl}
        {helpers.getFileLabel()}
        {helpers.getFileTooltip() ? (
          <TooltipEl attrs={{placement: Placement.Bottom, offset: 0, delay: 200}}>{helpers.getFileTooltip()}</TooltipEl>
        ) : null}
      </div>
      {this.attr(`enable-delete`) ? (
        <ButtonEl
          attrs={{
            theme: this.attr(`button-theme`),
            type: ButtonType.Destructive,
            icon: `trashcan`,
            tabindex: 0,
            disabled: this.attr(`disabled`),
          }}
          on={{click: helpers.handleDelete}}
          hook={{insert: helpers.deleteButtonInserted, destroy: helpers.deleteButtonDestroyed}}
        />
      ) : null}
    </div>
  );

  const shown = this.attr(`completed-filename`)
    ? complete
    : this.attr(`processing-description`)
      ? processing
      : uploadButton;

  return <div sel='.file-upload-block'>{shown}</div>;
}
